import { apiClient } from '@/lib/api';
import type {
  User,
  UserListResponse,
  UserQueryParams,
  CreateUserRequest,
  UpdateUserRequest,
  ResetPasswordRequest,
} from '../types/user.types';

const BASE_URL = '/api/v1/users';

export const usersApi = {
  getList: async (params: UserQueryParams = {}): Promise<UserListResponse> => {
    const searchParams = new URLSearchParams();
    if (params.role) searchParams.set('role', params.role);
    if (params.status) searchParams.set('status', params.status);
    if (params.search) searchParams.set('search', params.search);
    if (params.page) searchParams.set('page', params.page.toString());
    if (params.pageSize) searchParams.set('pageSize', params.pageSize.toString());
    if (params.includeSoftDeleted) searchParams.set('includeSoftDeleted', 'true');

    const response = await apiClient.get<UserListResponse>(
      `${BASE_URL}?${searchParams.toString()}`
    );
    return response.data;
  },

  getById: async (id: string): Promise<User> => {
    const response = await apiClient.get<User>(`${BASE_URL}/${id}`);
    return response.data;
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>(`${BASE_URL}/me`);
    return response.data;
  },

  create: async (request: CreateUserRequest): Promise<User> => {
    const response = await apiClient.post<User>(BASE_URL, request);
    return response.data;
  },

  update: async (id: string, request: UpdateUserRequest): Promise<User> => {
    const response = await apiClient.put<User>(`${BASE_URL}/${id}`, request);
    return response.data;
  },

  resetPassword: async (id: string, request: ResetPasswordRequest): Promise<void> => {
    await apiClient.post(`${BASE_URL}/${id}/reset-password`, request);
  },

  assignToLab: async (userId: string, labId: string): Promise<User> => {
    const response = await apiClient.post<User>(`${BASE_URL}/${userId}/labs`, { labId });
    return response.data;
  },

  removeFromLab: async (userId: string, labId: string): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/${userId}/labs/${labId}`);
  },

  deleteUser: async (id: string): Promise<void> => {
    await apiClient.delete(`${BASE_URL}/${id}`);
  },

  restoreUser: async (id: string): Promise<void> => {
    await apiClient.post(`${BASE_URL}/${id}/restore`, {});
  },
};
